import * as React from 'react';
import { ModalStackItem, ModalStackItemProps, ModalStackOptions } from "../interfaces/modals";
import { ModalContainerApi } from "../components/ModalContainer";

let _instance: React.RefObject<ModalContainerApi>;

export const setModalContainer = (instance: React.RefObject<ModalContainerApi>) => {
  if (instance && _instance) console.warn('ModalStack уже существует');
  _instance = instance;
}

export const addModal = <Props extends {}>(
  component: React.LazyExoticComponent<React.ComponentType<ModalStackItemProps<Props>>> | React.ComponentType<ModalStackItemProps<Props>>,
  props: Props,
  options: ModalStackOptions = {}
): ModalStackItem<Props> => {
  if (!_instance) throw('ModalStack не смонтирован');

  return _instance.current.open(component, props, options);
};

export const closeAllModals = () => {
  if (!_instance) throw('ModalStack не смонтирован');
  return _instance.current.closeAll();
}
